export const structureFilter = [
    {
        name: 'JPG',
        type: 'jpg'
    },
    {
        name: 'PDF',
        type: 'pdf'
    },
    {
        name: 'PNG',
        type: 'png'
    },
    {
        name: 'PSD',
        type: 'psd'
    },
    {
        name: 'EPS',
        type: 'eps'
    },
    {
        name: 'GIF',
        type: 'gif'
    },
    {
        name: 'DOC',
        type: 'doc'
    },
    {
        name: 'FLV',
        type: 'flv'
    },
    {
        name: 'SWF',
        type: 'swf'
    },
    {
        name: 'MP4',
        type: 'mp4'
    },
    {
        name: 'MP3',
        type: 'mp3'
    },
    {
        name: 'Image',
        type: 'image'
    },
    {
        name: 'Document',
        type: 'image'
    },
    {
        name: 'Animation',
        type: 'image'
    },
    {
        name: 'Video',
        type: 'image'
    },
    {
        name: 'Audio',
        type: 'image'
    }
]
export const fileType = {
    'JPC' : 'jpg',
    'JPB' : 'jpg',
    'BMC' : 'bmp',
    'BMW' : 'bmp',
    'WBC' : 'webp',
    'WBB' : 'webp',
    'AVC' : 'avif',
    'AVB' : 'avif',
    'SVC' : 'svg',
    'SVB' : 'svg',
    'TFC' : 'jpg',
    'TFB' : 'jpg',
    'DCC' : 'doc',
    'DCB' : 'doc',
    'PDC' : 'pdf',
    'PDB' : 'pdf',
    'PPC' : 'ppt',
    'PPB' : 'ppt',
    'GIF' : 'gif',
}
export const newFilter = [
    {
      name: 'PRINT',
      children: [
         {
            name: 'B/W',
            type: 'bw',
            endCode: ['BWC']
         },
         {
            name: 'COLOR',
            type: 'color',
            endCode: ['CLC']
         },
         {
            name: 'AI',
            type: 'ai',
            endCode: ['AIC']
         }
      ]
   },
      {
        name: 'DOCUMENT',
        children: [
            {
                name: 'DOC',
                type: 'doc',
                endCode: ['DCC','DCB']
            },
            {
                name: 'DOCX',
                type: 'docx',
                endCode: ['DCC','DCB']
            },
            {
                name: 'PDF',
                type: 'pdf',
                endCode: ['PDC', 'PDB']
            },
            {
                name: 'PPT',
                type: 'ppt',
                endCode: ['PPC','PPB']
            }
        ]
    },
  
 
    {
        name: 'AUDIO',
        children: [
            {
                name: 'MP3',
                type: 'mp3',
                endCode: ['MP3']
            },
            {
                name: 'WAV',
                type: 'wav',
                endCode: ['WAV']
            },
            {
                name: 'OGG',
                type: 'ogg',
                endCode: ['OGG']
            },
            {
                name: 'PCM',
                type: 'pcm',
                endCode: ['PCM']
            },
            {
                name: 'FLAC',
                type: 'flac',
                endCode: ['FLV']
            }
        ]
    },
    {
        name: 'VIDEO',
        children: [
            {
                name: 'MP4',
                type: 'mp4',
                endCode: ['MP4']
            },
            {
                name: 'WEBM',
                type: 'webm',
                endCode: ['WEB']
            },
            {
                name: 'OGG',
                type: 'ogg',
                endCode: ['OGG']
            }
        ]
    },
      {
        name: 'IMAGES',
        children: [
            {
                name: 'JPG',
                type: 'jpg',
                endCode: ['JPC', 'JPB']
            },
            {
                name: 'JPEG',
                type: 'jpeg',
                endCode: ['JPC', 'JPB']
            },
            {
                name: 'BMP',
                type: 'bmp',
                endCode: ['BMC','BMW']
            },
            {
                name: 'WEBP',
                type: 'webp',
                endCode: ['WBC','WBB']
            },
            {
                name: 'AVIF',
                type: 'avif',
                endCode: ['AVC','AVB']
            },
            {
                name: 'SVG',
                type: 'svg',
                endCode: ['SVC','SVB']
            },
            {
                name: 'TIFF',
                type: 'tiff',
                endCode: ['TFC','TFB']
            }
        ]
    },
    // {
    //     name: 'ANIMATIONS',
    //     children: [
    //         {
    //             name: 'GIF',
    //             type: 'gif',
    //             endCode: ['GIF']
    //         },
    //         {
    //             name: 'APNG',
    //             type: 'apng',
    //             endCode: ['APNG']
    //         }
    //     ]
    // },
    {
    name: 'B/W',
    children: [
        {
            name: 'BLACK & WHITE',
            type: 'bw',
            endCode: ['BWC']
        }
    ]
},
{
    name: 'COLOR',
    children: [
        {
            name: 'COLOR PRINT',
            type: 'color',
            endCode: ['CLC']
        }
    ]
},
{
    name: 'AI',
    children: [
        {
            name: 'AI GENERATED',
            type: 'ai',
            endCode: ['AIC']
        }
    ]
}, 
   

]
export const myImagesFilter = [
    {
        name: 'MY IMAGES', // Keeps the string data clean for internal state management
        label: (
            <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: '#6b95ee', // The smooth periwinkle blue from your image
                borderRadius: '100px',      // Smooth pill shape matching the layout
                padding: '3px 18px 3px 3px', // Tight left padding to position the icon cleanly
                color: 'white',
                fontWeight: '600',
                fontSize: '13px',           // Sized perfectly to line up with the white buttons
                fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                userSelect: 'none'
            }}>
                {/* 1. The White Circle with Cyan Ring */}
                <div style={{
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    width: '28px',
                    height: '28px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '2.5px solid #48daff', // The electric cyan glow border
                    marginRight: '10px',
                    boxSizing: 'border-box'
                }}>
                    {/* 2. Precision Hand Cursor SVG */}
                    <svg 
                        width="16px" 
                        height="16px" 
                        viewBox="0 0 24 24" 
                        fill="#ffffff" 
                        stroke="#2a2d34"    // Bold outline visibility
                        strokeWidth="2.8" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        style={{ 
                            transform: 'scaleX(-1) rotate(-4deg)', // Standard system pointer orientation
                            display: 'block'
                        }}
                    >
                        <path d="M5.5 10a2.5 2.5 0 0 1 5 0v3.5h1V5.5a1.5 1.5 0 0 1 3 0V12h1V7.5a1.5 1.5 0 0 1 3 0V12h1V9.5a1.5 1.5 0 0 1 3 0V16c0 4.5-3.5 6-6 6h-2c-3.5 0-6-2.5-6-6V10z" />
                    </svg>
                </div>
                
                {/* 3. Text Label */}
                <span style={{ 
                    whiteSpace: 'nowrap',
                    paddingRight: '6px'
                }}>
                    My images
                </span>
            </div>
        )
    }
];